import { BoxProps } from "@chakra-ui/react";
import { ReactElement } from "react";
import AxisConfig from "./AxisConfig";
import Content from "./Content";

export interface DataHeatmapConfig {
  xAxis: string | null;
  yAxis: string | null;
}

interface DataHeatmapProps extends DataHeatmapConfig, BoxProps {
  columns: Array<string>;
  onXAxisChange: (xAxis: string) => void;
  onYAxisChange: (yAxis: string) => void;
}

export default function DataHeatmap(props: DataHeatmapProps): ReactElement {
  const { xAxis, yAxis, ...rest } = props;

  return xAxis != null && yAxis != null ? (
    <Content xAxis={xAxis} yAxis={yAxis} {...rest} />
  ) : (
    <AxisConfig xAxis={xAxis} yAxis={yAxis} {...rest} />
  );
}
